import { createSelector, createFeatureSelector } from '@ngrx/store';

import { SoilTypeState } from 'src/app/shared/models';

import { adapter } from '../reducers/soil-type.reducer';

export const getSoilTypeState = createFeatureSelector<SoilTypeState>('soil-type');

const { selectAll } = adapter.getSelectors();

export const getSoilTypes = createSelector(getSoilTypeState, selectAll);
